module.exports = __webpack_public_path__ + "static/img/play.b9e621e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/play.gif
// module id = rIin
// module chunks = 80